module.exports = __webpack_public_path__ + "static/media/golds.4bf3a9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/golds.png
// module id = 53
// module chunks = 0